import React from "react";
import styles from "../Assets/css/masterclass.module.css";
import clock from "../Assets/img/Masterclass/Icon ionic-md-time.png";
import calendar from "../Assets/img/Masterclass/Icon material-today-black.png";
import masterBanner from "../Assets/img/Masterclass/blogs.png";
import Navbar from "../components/Navbar";
import MasterClassComponent from "../componentsofcourse/MasterClassComponent";
import { BASE_URL } from "../env";
import { useState, useEffect } from "react";

function MasterClass() {
	const [masterClassProps, setMasterClassProps] = useState([]);

	useEffect(() => {
		fetch(BASE_URL + "/getWebinar", {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		})
			.then((res) => res.json())
			.then((data) => {
				console.log("Data from CreateWebianr", data);
				setMasterClassProps(data.webinar);
			});
	}, []);

	return (
		<>
			<Navbar />
			<div style={styles.body}>
				<br />
				<br />
				<br />
				<div className={`container-fluid ${styles.blueBackJ}`}></div>
				<div className={`container p-0 mt-5 ${styles.archivedJ}`}>
					<h2>Archived</h2>
				</div>

				<div
					className={`container-fluid justify-content-center ${styles.archivedJ} my-5`}
				>
					<div>
						<div className="row justify-content-center">
							{/* <span style={{ padding: "1%" }}> */}
							{masterClassProps.map((item) => {
								return (
									<MasterClassComponent
										topic={item.subject}
										agenda={item.description}
										start_time={item.startTime}
										end_time={item.endTime}
										join_url={item.webinar_join_url}
										registration_url={item.registration_url}
										webinar_id={item.webinar_id}
										image={
											item.webinar
												? item.webinar.image
													? item.webinar.image
													: ""
												: ""
										}
									/>
								);
							})}

							{/* <div
                style={{
                  paddingLeft: "2%",
                  paddingTop: "3%",
                  paddingBottom: "3%",
                  height: "fit-content",
                  // boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                }}
                className={`col-xl-5 col-lg-4 col-md-6 mx-4 my-2 `}
              >
                <div className={`card ${styles.cardsArchivedJ}`}>
                  <img
                    style={{
                      height: "100px",
                      width: "100%",
                      borderRadius: "10px 10px 0px 0px",
                    }}
                    //   className={`card-img-top ${styles.cardsArchivedJ}`}
                    src={masterBanner}
                    alt="Card image cap"
                  />
                  <div className={styles.cardBody}>
                    <h5 className="card-title">Title</h5>
                    <p style={{ width: "60%" }} className="card-text">
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled it to make a
                      type specimen.
                    </p>

                    <div className={`d-flex ${styles.archivedButtonJ}`}>
                      <div className={`d-flex ${styles.archivedIconJ} mt-4`}>
                        <div style={{ marginRight: "1.5vw" }}>
                          <p className="cal-J">
                            <img src={calendar} alt="" />
                            SUN, 23rd MAY
                          </p>
                        </div>
                        <div className="mr-5">
                          <p className="clock-J">
                            <img src={clock} alt="" />
                            5PM - 6PM
                          </p>
                        </div>
                      </div>

                      <div className=" mt-4">
                        <div className="mb-2">
                          <button
                            style={{
                              color: "#212529",
                            }}
                            // btn ${styles.btn}
                            //   className="btn btn-light shadow"
                            className={`${styles.btn} ${styles.btnLight} shadow `}
                          >
                            AUDIT
                          </button>
                        </div>
                        <p
                          style={{
                            textAlign: "center",
                            fontSize: " 10px",
                            fontWeight: "900",
                          }}
                        >
                          5673 have Enrolled
                        </p>
                      </div>
                      <p
                        style={{
                          textAlign: "center",
                          fontSize: " 10px",
                          fontFamily: "Poppins-Black",
                        }}
                      >
                        5673 have Enrolled
                      </p>
                    </div>
                  </div>
                </div>
              </div> */}
							{/* <div
                style={{
                  paddingRight: "2%",
                  paddingTop: "3%",
                  paddingBottom: "3%",
                  height: "fit-content",
                  // boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                }}
                className={`col-xl-5 col-lg-4 col-md-6 mx-4 my-2 `}
              >
                <div className={`card ${styles.cardsArchivedJ}`}>
                  <img
                    style={{
                      height: "100px",
                      width: "100%",
                      borderRadius: "10px 10px 0px 0px",
                    }}
                    //   className={`card-img-top ${styles.cardsArchivedJ}`}
                    src={masterBanner}
                    alt="Card image cap"
                  />
                  <div className={styles.cardBody}>
                    <h5 className="card-title">Title</h5>
                    <p style={{ width: "60%" }} className="card-text">
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled it to make a
                      type specimen.
                    </p>

                    <div className={`d-flex ${styles.archivedButtonJ}`}>
                      <div className={`d-flex ${styles.archivedIconJ} mt-4`}>
                        <div style={{ marginRight: "1.5vw" }}>
                          <p className="cal-J">
                            <img src={calendar} alt="" />
                            SUN, 23rd MAY
                          </p>
                        </div>
                        <div className="mr-5">
                          <p className="clock-J">
                            <img src={clock} alt="" />
                            5PM - 6PM
                          </p>
                        </div>
                      </div>

                      <div className=" mt-4">
                        <div className="mb-2">
                          <button
                            style={{
                              color: "#212529",
                            }}
                            // btn ${styles.btn}
                            //   className="btn btn-light shadow"
                            className={`${styles.btn} ${styles.btnLight} shadow `}
                          >
                            AUDIT
                          </button>
                        </div>
                        <p
                          style={{
                            textAlign: "center",
                            fontSize: " 10px",
                            fontWeight: "900",
                          }}
                        >
                          5673 have Enrolled
                        </p>
                      </div>
                      <p
                        style={{
                          textAlign: "center",
                          fontSize: " 10px",
                          fontFamily: "Poppins-Black",
                        }}
                      >
                        5673 have Enrolled
                      </p>
                    </div>
                  </div>
                </div>
              </div> */}
							{/* <div
                style={{
                  paddingLeft: "2%",
                  paddingTop: "3%",
                  paddingBottom: "3%",
                  height: "fit-content",
                  // boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                }}
                className={`col-xl-5 col-lg-4 col-md-6 mx-4 my-2`}
              >
                <div className={`card ${styles.cardsArchivedJ}`}>
                  <img
                    style={{
                      height: "100px",
                      width: "100%",
                      borderRadius: "10px 10px 0px 0px",
                    }}
                    //   className={`card-img-top ${styles.cardsArchivedJ}`}
                    src={masterBanner}
                    alt="Card image cap"
                  />
                  <div className={styles.cardBody}>
                    <h5 className="card-title">Title</h5>
                    <p style={{ width: "60%" }} className="card-text">
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled it to make a
                      type specimen.
                    </p>

                    <div className={`d-flex ${styles.archivedButtonJ}`}>
                      <div className={`d-flex ${styles.archivedIconJ} mt-4`}>
                        <div style={{ marginRight: "1.5vw" }}>
                          <p className="cal-J">
                            <img src={calendar} alt="" />
                            SUN, 23rd MAY
                          </p>
                        </div>
                        <div className="mr-5">
                          <p className="clock-J">
                            <img src={clock} alt="" />
                            5PM - 6PM
                          </p>
                        </div>
                      </div>

                      <div className=" mt-4">
                        <div className="mb-2">
                          <button
                            style={{
                              color: "#212529",
                            }}
                            // btn ${styles.btn}
                            //   className="btn btn-light shadow"
                            className={`${styles.btn} ${styles.btnLight} shadow `}
                          >
                            AUDIT
                          </button>
                        </div>
                        <p
                          style={{
                            textAlign: "center",
                            fontSize: " 10px",
                            fontWeight: "900",
                          }}
                        >
                          5673 have Enrolled
                        </p>
                      </div>
                      <p
                        style={{
                          textAlign: "center",
                          fontSize: " 10px",
                          fontFamily: "Poppins-Black",
                        }}
                      >
                        5673 have Enrolled
                      </p>
                    </div>
                  </div>
                </div>
              </div> */}
							{/* <div
                style={{
                  paddingRight: "2%",
                  paddingTop: "3%",
                  paddingBottom: "3%",
                  height: "fit-content",
                  // boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                }}
                className={`col-xl-5 col-lg-4 col-md-6 mx-4 my-2`}
              >
                <div className={`card ${styles.cardsArchivedJ}`}>
                  <img
                    style={{
                      height: "100px",
                      width: "100%",
                      borderRadius: "10px 10px 0px 0px",
                    }}
                    //   className={`card-img-top ${styles.cardsArchivedJ}`}
                    src={masterBanner}
                    alt="Card image cap"
                  />
                  <div className={styles.cardBody}>
                    <h5 className="card-title">Title</h5>
                    <p style={{ width: "60%" }} className="card-text">
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled it to make a
                      type specimen.
                    </p>

                    <div className={`d-flex ${styles.archivedButtonJ}`}>
                      <div className={`d-flex ${styles.archivedIconJ} mt-4`}>
                        <div style={{ marginRight: "1.5vw" }}>
                          <p className="cal-J">
                            <img src={calendar} alt="" />
                            SUN, 23rd MAY
                          </p>
                        </div>
                        <div className="mr-5">
                          <p className="clock-J">
                            <img src={clock} alt="" />
                            5PM - 6PM
                          </p>
                        </div>
                      </div>

                      <div className=" mt-4">
                        <div className="mb-2">
                          <button
                            style={{
                              color: "#212529",
                            }}
                            // btn ${styles.btn}
                            //   className="btn btn-light shadow"
                            className={`${styles.btn} ${styles.btnLight} shadow `}
                          >
                            AUDIT
                          </button>
                        </div>
                        <p
                          style={{
                            textAlign: "center",
                            fontSize: " 10px",
                            fontWeight: "900",
                          }}
                        >
                          5673 have Enrolled
                        </p>
                      </div>
                      <p
                        style={{
                          textAlign: "center",
                          fontSize: " 10px",
                          fontFamily: "Poppins-Black",
                        }}
                      >
                        5673 have Enrolled
                      </p>
                    </div>
                  </div>
                </div>
              </div> */}
							{/* <div
                style={{
                  paddingRight: "2%",
                  paddingTop: "3%",
                  paddingBottom: "3%",
                  height: "fit-content",
                  // boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                }}
                className={`col-xl-5 col-lg-4 col-md-6 mx-4 my-2 `}
              >
                <div className={`card ${styles.cardsArchivedJ}`}>
                  <img
                    style={{
                      height: "100px",
                      width: "100%",
                      borderRadius: "10px 10px 0px 0px",
                    }}
                    //   className={`card-img-top ${styles.cardsArchivedJ}`}
                    src={masterBanner}
                    alt="Card image cap"
                  />
                  <div className={styles.cardBody}>
                    <h5 className="card-title">Title</h5>
                    <p style={{ width: "60%" }} className="card-text">
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled it to make a
                      type specimen.
                    </p>

                    <div className={`d-flex ${styles.archivedButtonJ}`}>
                      <div className={`d-flex ${styles.archivedIconJ} mt-4`}>
                        <div style={{ marginRight: "1.5vw" }}>
                          <p className="cal-J">
                            <img src={calendar} alt="" />
                            SUN, 23rd MAY
                          </p>
                        </div>
                        <div className="mr-5">
                          <p className="clock-J">
                            <img src={clock} alt="" />
                            5PM - 6PM
                          </p>
                        </div>
                      </div>

                      <div className=" mt-4">
                        <div className="mb-2">
                          <button
                            style={{
                              color: "#212529",
                            }}
                            // btn ${styles.btn}
                            //   className="btn btn-light shadow"
                            className={`${styles.btn} ${styles.btnLight} shadow `}
                          >
                            AUDIT
                          </button>
                        </div>
                        <p
                          style={{
                            textAlign: "center",
                            fontSize: " 10px",
                            fontWeight: "900",
                          }}
                        >
                          5673 have Enrolled
                        </p>
                      </div>
                      <p
                        style={{
                          textAlign: "center",
                          fontSize: " 10px",
                          fontFamily: "Poppins-Black",
                        }}
                      >
                        5673 have Enrolled
                      </p>
                    </div>
                  </div>
                </div>
              </div> */}
							{/* <div
                style={{
                  paddingRight: "2%",
                  paddingTop: "3%",
                  paddingBottom: "3%",
                  height: "fit-content",
                  // boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                }}
                className={`col-xl-5 col-lg-4 col-md-6 mx-4 my-2`}
              >
                <div className={`card ${styles.cardsArchivedJ}`}>
                  <img
                    style={{
                      height: "100px",
                      width: "100%",
                      borderRadius: "10px 10px 0px 0px",
                    }}
                    //   className={`card-img-top ${styles.cardsArchivedJ}`}
                    src={masterBanner}
                    alt="Card image cap"
                  />
                  <div className={styles.cardBody}>
                    <h5 className="card-title">Title</h5>
                    <p style={{ width: "60%" }} className="card-text">
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled it to make a
                      type specimen.
                    </p>

                    <div className={`d-flex ${styles.archivedButtonJ}`}>
                      <div className={`d-flex ${styles.archivedIconJ} mt-4`}>
                        <div style={{ marginRight: "1.5vw" }}>
                          <p className="cal-J">
                            <img src={calendar} alt="" />
                            SUN, 23rd MAY
                          </p>
                        </div>
                        <div className="mr-5">
                          <p className="clock-J">
                            <img src={clock} alt="" />
                            5PM - 6PM
                          </p>
                        </div>
                      </div>

                      <div className=" mt-4">
                        <div className="mb-2">
                          <button
                            style={{
                              color: "#212529",
                            }}
                            // btn ${styles.btn}
                            //   className="btn btn-light shadow"
                            className={`${styles.btn} ${styles.btnLight} shadow `}
                          >
                            AUDIT
                          </button>
                        </div>
                        <p
                          style={{
                            textAlign: "center",
                            fontSize: " 10px",
                            fontWeight: "900",
                          }}
                        >
                          5673 have Enrolled
                        </p>
                      </div>
                      <p
                        style={{
                          textAlign: "center",
                          fontSize: " 10px",
                          fontFamily: "Poppins-Black",
                        }}
                      >
                        5673 have Enrolled
                      </p>
                    </div>
                  </div>
                </div>
              </div> */}
							{/* <div
                style={{
                  paddingRight: "2%",
                  paddingTop: "3%",
                  paddingBottom: "3%",
                  height: "fit-content",
                  // boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                }}
                className={`col-xl-5 col-lg-4 col-md-6 mx-4 my-2 `}
              >
                <div className={`card ${styles.cardsArchivedJ}`}>
                  <img
                    style={{
                      height: "100px",
                      width: "100%",
                      borderRadius: "10px 10px 0px 0px",
                    }}
                    //   className={`card-img-top ${styles.cardsArchivedJ}`}
                    src={masterBanner}
                    alt="Card image cap"
                  />
                  <div className={styles.cardBody}>
                    <h5 className="card-title">Title</h5>
                    <p style={{ width: "60%" }} className="card-text">
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled it to make a
                      type specimen.
                    </p>

                    <div className={`d-flex ${styles.archivedButtonJ}`}>
                      <div className={`d-flex ${styles.archivedIconJ} mt-4`}>
                        <div style={{ marginRight: "1.5vw" }}>
                          <p className="cal-J">
                            <img src={calendar} alt="" />
                            SUN, 23rd MAY
                          </p>
                        </div>
                        <div className="mr-5">
                          <p className="clock-J">
                            <img src={clock} alt="" />
                            5PM - 6PM
                          </p>
                        </div>
                      </div>

                      <div className=" mt-4">
                        <div className="mb-2">
                          <button
                            style={{
                              color: "#212529",
                            }}
                            // btn ${styles.btn}
                            //   className="btn btn-light shadow"
                            className={`${styles.btn} ${styles.btnLight} shadow `}
                          >
                            AUDIT
                          </button>
                        </div>
                        <p
                          style={{
                            textAlign: "center",
                            fontSize: " 10px",
                            fontWeight: "900",
                          }}
                        >
                          5673 have Enrolled
                        </p>
                      </div>
                      <p
                        style={{
                          textAlign: "center",
                          fontSize: " 10px",
                          fontFamily: "Poppins-Black",
                        }}
                      >
                        5673 have Enrolled
                      </p>
                    </div>
                  </div>
                </div>
              </div> */}
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default MasterClass;
